import { parseDateOnly } from '@/utils/dateOnly';

/** Clause holding the "written acceptance on or before" date. */
export const ACCEPTANCE_DEADLINE_CLAUSE_ID = 'offer-expiration';

/**
 * The written-acceptance date if it has passed (before today), else null.
 * The server refuses to generate or sign the contract after it.
 */
export function passedAcceptanceDeadline(
  contract: { timeline?: { offerGoodUntillDate?: string } } | null | undefined
): Date | null {
  const deadline = parseDateOnly(contract?.timeline?.offerGoodUntillDate);
  if (!deadline) return null;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return deadline < today ? deadline : null;
}
